export default {
  methods: {
    phoneNumberWithoutFormat(phone) {
      const digitsOnly = phone.replace(/\D/g, "");
      return digitsOnly;
    },
    formatPhoneNumber(phone) {
      if (!phone) {
        return null;
      }
      const extMatch = phone.match(/(?:ext\.?|x)\s?(\d+)/i);
      const extension = extMatch ? extMatch[1] : null;
      let onlyNumbers = phone.replace(/\D/g, "");
      const regex = /^(1)?(\d{3})(\d{3})(\d{4})/;
      let prefix = "";
      if (onlyNumbers.startsWith("1")) {
        prefix = "1";
        onlyNumbers = onlyNumbers.slice(1);
      } else if (onlyNumbers.startsWith("52")) {
        prefix = "52";
        onlyNumbers = onlyNumbers.slice(2);
      }
      const match = regex.exec(onlyNumbers);
      const intlCode = prefix;
      if (match) {
        const first = match[2];
        const second = match[3];
        const third = match[4];
        let formatted = `${intlCode ? `${intlCode} ` : ""}(${first}) ${second}-${third}`;
        if (extension) {
          formatted += ` ext. ${extension}`;
        }
        return formatted;
      }

      return "";
    }

  },
};
